import { SUPPORTED_MDA_TRADELINE_TYPES } from 'shared/constants';

const filterLiabilitiesByMDASupported = (liabilities) => {
	if (!liabilities) return [];

	console.log(liabilities);

	return liabilities.filter((liability) =>
		SUPPORTED_MDA_TRADELINE_TYPES.includes(
			liability.tradeLineType || liability.type
		)
	);
};

export default filterLiabilitiesByMDASupported;
